var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-wrap"},[_c('el-container',[_c('el-header',{staticClass:"header-ban"},[_c('HeaderBan')],1),_c('el-container',{staticStyle:{"margin":"0","height":"94vh"}},[_c('el-aside',{attrs:{"width":"240px"}},[_c('SideLeft')],1),_c('el-main',{staticClass:"mainbg"},[_c('SideRight')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }